// extracted by mini-css-extract-plugin
module.exports = {"productsContainer":"IncompleteVisitsTable_productsContainer_2Z3xN","emptyItems":"IncompleteVisitsTable_emptyItems_3riIn","scrollDiv":"IncompleteVisitsTable_scrollDiv_1VbME"};